const endPoints = {
    autoComplete: {
        mention: '/field-values/mention',
        tagSearch: '/field-values/ts.tags'
    },
    search: {
        customers: '/customers',
        organizations: '/organizations',
        tickets: '/tickets/search'
    },
    chat: {
        acceptChatFromQueue: '/chats/queue/accept',
        activeChatEntities: '/chats/mine',
        recentChatQueue: '/chats/queue/size',
        resumeChat: '/chats/',
        history: ['/chats/', '/history'],
        historyByTicketKey: '/chats/info/',
        acknowledge: ['/chats/', '/ack-messages'],
        createChatSession: 'http://localhost:8090/chat-sessions',
        chatEntity: 'http://localhost:3000/chats',
        agentChatCurrencyLimit: 'http://localhost:3000/concurrency-limit'
    },
    reports: {
        dashboard: {
            agentStatusCount: '/reports/dashboard/agent-status-count',
            agentStatusList: '/reports/dashboard/agent-status-list',
            openedTicketsCount: '/reports/dashboard/opened-tickets-count',
            solvedTicketsCount: '/reports/dashboard/solved-tickets-count',
            chatQueueCount: '/reports/dashboard/chat-queue-count',
            chatOccupancyRatio: '/reports/dashboard/chat-occupancy-ratio'
        }
    }
} as const;

export default endPoints;
